module.exports = __webpack_public_path__ + "img/5.f28b5ace.jpg";